/**
 * Geometry for the docked entry point, transcribed from the design
 * export. Kept in a dedicated module because component files never
 * export constants.
 */

/** Size (px) of the brand dots mark in both resting sizes. */
export const DOCK_BRAND_ICON_SIZE_PX = 16;

/** Size (px) of the minimize glyph inside the expanded card's header. */
export const DOCK_TOGGLE_GLYPH_SIZE_PX = 20;

/** Size (px) of the expand glyph on the minimized bar. */
export const DOCK_BAR_GLYPH_SIZE_PX = 16;

/** Width (px) of the minimized bar. */
export const DOCK_BAR_WIDTH_PX = 335;

/** Gap (px) between the bar's icon, label, and glyph. */
export const DOCK_BAR_GAP_PX = 12;

/**
 * Bottom padding (px) of the minimized bar. Smaller than the top
 * padding so the label sits optically centred against the edge the
 * bar is tucked into; no spacing token carries this value.
 */
export const DOCK_BAR_PADDING_BOTTOM_PX = 12;

/**
 * Width (px) of the skeleton that stands in for the bar's label while
 * consent is looked up. Approximates "Fleet AI Assistant" set in
 * `body_medium`; no design specifies it.
 */
export const DOCK_BAR_LABEL_SKELETON_WIDTH_PX = 120;

/** Thickness (px) of the gradient border shared by the bar and the card. */
export const DOCK_BORDER_WIDTH_PX = 1;

/** Sweep direction of the gradient border shared by the bar and the card. */
export const DOCK_BORDER_GRADIENT_ANGLE = '90deg';

/** Skeleton chips rendered while the suggestion request is in flight. */
export const DOCK_LOADING_CHIP_COUNT = 3;

/** Width of the upsell CTA, wide enough to hold the label on one line. */
export const DOCK_UPSELL_CTA_WIDTH = '160px';
